//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      text: false,
      permission: {},
      option: {
        expand: true,
        column: [{
          label: "姓名",
          prop: "name"
        }, {
          label: "年龄",
          prop: "sex"
        }]
      },
      data: [{
        id: 1,
        name: "张三",
        sex: 12
      }, {
        id: 2,
        name: "李四",
        sex: 20
      }]
    };
  },
  watch: {
    text: function text() {
      if (this.text === true) {
        this.permission = {
          delBtn: false,
          addBtn: false
        };
      } else {
        this.permission = {
          delBtn: true,
          addBtn: true
        };
      }
    }
  }
};